import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/login'
import DashBoard from '../views/dashboard'
import { getUserInfo } from '../utils/auth'

// 动态添加路由
// https://www.bilibili.com/video/BV16t4y1S7Eh/?spm_id_from=333.788.recommend_more_video.0
// 使用路由元信息控制路由访问权限
// https://www.bilibili.com/video/BV1LT4y1w7v7/?spm_id_from=333.788.recommend_more_video.18
// 为什么使用命名路由
// https://www.bilibili.com/video/BV1Sv411v7DG/?spm_id_from=333.788.recommend_more_video.5
// 嵌套路由
// https://www.bilibili.com/video/BV18Z4y1K7h9/?spm_id_from=333.788.recommend_more_video.31
// 路由重定向
// https://www.bilibili.com/video/BV1Hy4y1y7Yp/?spm_id_from=333.788.recommend_more_video.2
// 使用过滤器刷选数据filters
// https://www.bilibili.com/video/BV15y4y1y7wM/?spm_id_from=333.788.recommend_more_video.7
Vue.use(Router)
export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      // component: Login,
      // name: 'Login'
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login,
      name: 'Login'
    },
    {
      path: '/dashboard',
      component: DashBoard,
      name: 'DashBoard',
      // redirect: '/dashboard/book'
      children: [
        // {
        //   path: '/',
        //   name: 'book1',
        //   meta: { index: 0, title: '开始订舱' },
        //   component: () => import('@/views/book')
        // },
        // {
        //   path: 'book',
        //   name: 'book',
        //   meta: { index: 0, title: '开始订舱' },
        //   component: () => import('@/views/book')
        // },
        // {
        //   path: 'order',
        //   name: 'orderList',
        //   meta: { index: 1, title: '订单列表' },
        //   component: () => import('@/views/orderList')
        // },
        {
          path: 'refresh',
          name: 'refresh',
          meta: { index: 1, title: '刷箱列表' },
          component: () => import('@/views/refresh')
        },
        {
          path: 'boxedList',
          name: 'boxedList',
          meta: { index: 2, title: '已刷箱列表' },
          component: () => import('@/views/boxed_list')
        },
        {
          path: 'eptrade',
          name: 'eptrade',
          meta: { index: 3, title: 'EP交易' },
          component: () => import('@/views/eptrade/eptrade.vue')
        },
        {
          path: 'printed-eptrade',
          name: 'printed-eptrade',
          meta: { index: 4, title: 'EP订单' },
          component: () => import('@/views/printed-eptrade/PrintedEptrade.vue')
        }
      ]
    }
  ]
})
router.beforeEach(function (to, from, next) {
  if (getUserInfo() === null) {
    console.log('from = ', from)
    if (to.path !== '/login') {
      return next('/login')
    }
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js